import { useState } from "react";
import { toast } from "react-toastify";
import Modal from "../layout/Modal";
import TextInput from "../layout/TextInput";
import MultiSelect from "../layout/MultiSelect";
import Button from "../layout/Button";
import useFormValidation from "../../hooks/formValidation";
import {
  WhatsappContact,
  WhatsappGroup,
  createGroup,
  addGroupAccess,
} from "../../model/whatsapp.model";
import { formatPhoneDisplay } from "../whatsapp/format";

type Option = { value: string; label: string };
// Mesmo tipo local de Whatsapp.page.tsx (não importado de lá — importar de
// volta criaria dependência circular, a página é quem importa este modal).
type Extension = { value: string; name: string };

function CreateGroupModal(props: {
  contacts: WhatsappContact[];
  extensions: Extension[];
  onClose: () => void;
  onCreated: (group: WhatsappGroup) => void;
}) {
  const [name, setName] = useState("");
  const [selected, setSelected] = useState<Option[]>([]);
  const [selectedAgents, setSelectedAgents] = useState<Option[]>([]);
  const [submitting, setSubmitting] = useState(false);

  const formValidation = useFormValidation();

  const options: Option[] = props.contacts.map((c) => ({
    value: c.id,
    label: `${c.name} (${formatPhoneDisplay(c.phone)})`,
  }));
  const agentOptions: Option[] = props.extensions.map((e) => ({
    value: e.value,
    label: e.name,
  }));

  const onSubmit = async () => {
    if (!formValidation.validateForm() || submitting) return;
    setSubmitting(true);
    const result = await createGroup({
      name: name.trim(),
      contactIds: selected.map((o) => o.value),
    });
    if (result.error) {
      setSubmitting(false);
      toast.error("Não foi possível criar o grupo.");
      return;
    }
    // Opcional — grupo nasce aberto pra empresa inteira por padrão (ver
    // WhatsappGroup.accessUserIds); só restringe se algum atendente foi
    // escolhido aqui na criação.
    if (selectedAgents.length > 0) {
      const accessResults = await Promise.all(
        selectedAgents.map((o) =>
          addGroupAccess({ groupId: result.data.id, userId: o.value }),
        ),
      );
      if (accessResults.some((r) => r.error)) {
        toast.error("Grupo criado, mas não deu pra restringir o acesso a todos os atendentes escolhidos.");
      }
    }
    setSubmitting(false);
    props.onCreated(result.data);
  };

  return (
    <Modal shown title="Novo grupo" onClose={props.onClose} className="w-[420px]">
      <TextInput
        title="Nome do grupo"
        placeholder="Ex: Suporte Cliente X"
        value={name}
        setter={setName}
        formValidation={formValidation}
        required
      />

      <hr className="border-t-2 border-white-dark my-4" />

      <MultiSelect
        title="Participantes"
        options={options}
        value={selected}
        //@ts-ignore
        setter={setSelected}
        formValidation={formValidation}
        required
      />
      <div className="mt-4">
        <MultiSelect
          title="Atendentes com acesso (opcional)"
          options={agentOptions}
          value={selectedAgents}
          //@ts-ignore
          setter={setSelectedAgents}
          formValidation={formValidation}
        />
        <p className="text-[10.5px] text-gray-dark mt-1">
          Deixe em branco pra qualquer atendente da empresa poder ver e usar este grupo. Escolher
          alguém aqui já restringe o acesso só a quem foi escolhido.
        </p>
      </div>
      <div className="flex justify-end gap-2.5 mt-5">
        <Button outline color="gray" onClick={props.onClose}>
          Cancelar
        </Button>
        <Button onClick={onSubmit} disabled={submitting} isLoading={submitting}>
          Criar grupo
        </Button>
      </div>
    </Modal>
  );
}

export default CreateGroupModal;
